// extracted by mini-css-extract-plugin
export var border = "_1e-7";
export var brand = "_1e-r";
export var button = "_1e-j";
export var center = "_1e-9";
export var centered = "_1e-5";
export var closeButton = "_1e-b";
export var disabledWrapper = "_1e-k";
export var error = "_1e-n";
export var extraLarge = "_1e-4";
export var extraSmall = "_1e-1";
export var fill = "_1e-g";
export var footer = "_1e-f";
export var footerAction = "_1e-h";
export var footerButtons = "_1e-i";
export var header = "_1e-6";
export var icon = "_1e-m";
export var info = "_1e-q";
export var inline = "_1e-8";
export var large = "_1e-3";
export var main = "_1e-c";
export var modal = "_1e-0";
export var neutral = "_1e-s";
export var noPadding = "_1e-e";
export var none = "_1e-t";
export var scrollable = "_1e-d";
export var small = "_1e-2";
export var success = "_1e-p";
export var tight = "_1e-l";
export var titleIcon = "_1e-a";
export var warn = "_1e-o";